export enum ApiErrorType {

    // Application
    NOT_FOUND = 'NotFoundError',

    DUPLICATE = 'DuplicateError',
    USER_DUPLICATE = 'UserDuplicateError',
    PASSWORD_WEAK = 'PasswordWeakError',
    PASSWORD_INVALID = 'PasswordInvalidError',
    EMAIL_VALIDATION = 'EmailValidationError',
    ORGANIZATION_INACTIVE = 'OrganizationInactiveError'
}

export default ApiErrorType;